import React from 'react'
import { Row, Col, FormControl } from 'react-bootstrap'
import i18next from 'i18next'
import classNames from 'classnames'
import LanguageSelectorFormControl from './LanguageSelectorFormControl'
import SideBox from './SideBox'

import buttonStyles from './styles/button.scss'
import adminStyles from './styles/admin.scss'
import comparisonStyles from './styles/comparison.scss'

import introductionIllustration from './../assets/images/wopi-puzzle.png'

export default class GroupDriversSelection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      language: props.language
    }
  }

  render() {
    const { selectedProfiles, onToggleSelection, currentOrganisationId } = this.props

    return (
      <div>
        <SideBox>
          <div className={adminStyles.container} style={{ minHeight: 340 }}>
            <Row>
              <Col sm={12}>
                <h3>
                  {i18next.t('selected_profiles')}{' '}
                  <small>
                    {selectedProfiles.count()} {i18next.t('pcs')}
                  </small>
                </h3>

                <Row>
                  <Col xs={12} style={{}}>
                    {selectedProfiles.count() == 0 && (
                      <div>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: i18next.t('group_drivers_introduction').replace(/\\n/g, '<br/>')
                          }}
                        />

                        <img
                          src={introductionIllustration}
                          style={{ width: 150, float: 'right' }}
                        />
                      </div>
                    )}

                    {selectedProfiles.map((profile, key) => {
                      return (
                        <Row className={comparisonStyles.selectedProfile} key={key}>
                          <Col xs={11} sm={9}>
                            <header>
                              {profile.personalInformation.givenName}{' '}
                              {profile.personalInformation.familyName}
                              <br />
                              <small>{profile.invitation.email}</small>
                            </header>
                          </Col>

                          <Col xs={1} sm={3} onClick={onToggleSelection(profile)}>
                            <button>&otimes;</button>
                          </Col>
                        </Row>
                      )
                    })}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </SideBox>

        <section style={{ marginBottom: 40, backgroundColor: '#FFF8F4', padding: 20 }}>
          <div className={adminStyles.container}>
            <Row>
              <Col md={12}>
                <FormControl
                  name="name"
                  type="text"
                  value={this.state.name}
                  placeholder={i18next.t('name_for_group')}
                  onChange={e => this.setState({ name: e.target.value })}
                  className={comparisonStyles.inputForGroupProfileName}
                  disabled={selectedProfiles.count() < 2}
                />

                <div className={comparisonStyles.inputForGroupProfileLanguage}>
                  <LanguageSelectorFormControl
                    shouldTranslateLanguages={true}
                    defaultValue={this.state.language}
                    onChange={e => this.setState({ [e.target.name]: e.target.value })}
                    withoutFormGroup={true}
                    isDisabled={selectedProfiles.count() < 2}
                  />
                </div>

                <a
                  href={`/api/organisations/${currentOrganisationId}/profiles/group-drivers/${
                    this.state.language
                  }?name=${encodeURIComponent(this.state.name.trim())}&uuid=${selectedProfiles
                    .map(p => p.uuid)
                    .join('&uuid=')}`}
                >
                  <button
                    className={classNames(
                      buttonStyles.button,
                      buttonStyles.buttonBlock,
                      buttonStyles.buttonLarge
                    )}
                    disabled={selectedProfiles.count() < 2}
                  >
                    {i18next.t('download_group_drivers')}
                  </button>
                </a>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/GroupDriversSelection.js